/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable no-underscore-dangle */
/* eslint-disable react/no-this-in-sfc */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable react/prop-types */
/* eslint-disable import/no-unresolved */
/* eslint-disable camelcase */
import { useEffect, useRef, useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { cancelOrder, editBracketOrder } from 'actions/trade';
import { ORDER_CATEGORY } from 'constants/enums';
import { useGrowthbookFeatureValue } from 'growthbook';
import { round_by_tick_size } from 'helpers/formulas';
import { addLogsToSentry } from 'helpers/sentry';
import { getStopOrderType, isEmpty, isMobileOrTablet } from 'helpers/utils';
import {
  allOpenStopOrdersSelector,
  futuresOpenStopOrdersSelector,
} from 'selectors/holdingsSelectors';
import { userSelector } from 'selectors/otherSelectors';

const lineTextBuilder = order => {
  let trailAmountValue = order.trail_amount;
  if (trailAmountValue && order && order.product) {
    trailAmountValue = round_by_tick_size(
      Number(trailAmountValue),
      order.product.tick_size
    );
  }
  const trailAmount = trailAmountValue ? `(${trailAmountValue})` : '';

  const orderType = getStopOrderType(order);
  const stopPrice = round_by_tick_size(order.stop_price, order.product.tick_size);

  let text = `${orderType} ; Trigger ${
    order.side === 'sell' ? '>=' : '<='
  } ${stopPrice} ${trailAmount}`;
  if (orderType === 'Bracket - SL' || orderType === 'Bracket - SL-Trail') {
    text = `${orderType} ; Trigger ${
      order.side === 'sell' ? '<=' : '>='
    } ${stopPrice} ${trailAmount}`;
  }
  if (orderType === 'Stop Limit') {
    text = `${orderType} : ${order.limit_price}; Trigger ${
      order.side === 'sell' ? '<=' : '>='
    } ${stopPrice}`;
  }

  return text;
};
const OpenStopOrderLine = ({
  order,
  widgetRef,
  isNewTab,
  isChartReady,
  currentActiveTab,
  activeChartSymbol,
}) => {
  const orderLine = { current: null };
  const [showOrderLine, setShowOrderLine] = useState(false);
  const previousTab = useRef('');
  const dispatch = useDispatch();
  const user = useSelector(userSelector);
  const color = order.side === 'sell' ? '#e55541' : '#28d591';
  const buttonCloseColor = '#153034';
  const buttonBorderColor = order.side === 'sell' ? '#e55541' : '#00ce7d';
  const orderType = getStopOrderType(order);
  const isStopLimit = orderType === 'Stop Limit';
  const isStopMarket = orderType === 'Stop Market';
  const isTrailingStop = orderType === 'Trailing Stop';
  const isTakeProfitOrder = orderType === 'Bracket - TP' || orderType === 'Bracket - SL';

  useEffect(() => {
    const timeoutId = setTimeout(async () => {
      if (isChartReady && widgetRef?.current?._id && !isEmpty(order) && showOrderLine) {
        const text = lineTextBuilder(order);
        try {
          const chart = widgetRef.current.activeChart();
          if (!chart) throw new Error('Chart not available');
          const orderLineInstance = await chart.createOrderLine();

          orderLineInstance.onCancel(function () {
            this.setText('Cancelling...');
            dispatch(
              cancelOrder(
                {
                  id: order.id,
                  product_id: order.product.id,
                },
                {
                  chart: true,
                },
                {
                  orderCategory: ORDER_CATEGORY.STOP_ORDER,
                }
              )
            );
          });

          orderLineInstance.setModifyTooltip('Quantity');
          orderLineInstance.setText(text);
          orderLineInstance.setLineColor(color);
          orderLineInstance.setBodyBorderColor(buttonBorderColor);
          orderLineInstance.setBodyBackgroundColor('#153034');
          orderLineInstance.setQuantityBackgroundColor(color);
          orderLineInstance.setQuantityBorderColor(color);
          orderLineInstance.setBodyTextColor('#ffffff');
          orderLineInstance.setBodyFont('12px Verdana');
          orderLineInstance.setQuantityFont('12px Verdana');
          orderLineInstance.setCancelButtonBorderColor(buttonBorderColor);
          orderLineInstance.setCancelButtonBackgroundColor(buttonCloseColor);
          orderLineInstance.setCancelButtonIconColor('#e55541');
          orderLineInstance.setPrice(order.stop_price);
          orderLineInstance.setQuantity(order.unfilled_size);
          orderLineInstance.setExtendLeft(true);
          orderLineInstance.setLineLength(isNewTab ? 70 : 55);

          if (isMobileOrTablet()) {
            orderLineInstance.setBodyFont('10px Verdana');
            orderLineInstance.setQuantityFont('10px Verdana');
          }

          // Attach onMove handlers based on order type
          if (isStopLimit || isStopMarket) {
            orderLineInstance.onMove(function () {
              this.setText('Updating...');
              dispatch(
                editBracketOrder(
                  {
                    id: order.id,
                    product_id: order.product.id,
                    stop_price: this.getPrice().toString(),
                  },
                  {
                    chart: true,
                  }
                )
              ).catch(() => {
                if (orderLine.current) {
                  orderLine.current.setPrice(order.stop_price);
                  orderLine.current.setText(text);
                }
              });
            });
          } else if (isTrailingStop) {
            orderLineInstance.onMove(function () {
              this.setText('Updating...');
              const triggerPrice = Number(order.stop_price);
              const updatedTriggerPrice = this.getPrice();
              let trail_amount;

              if (updatedTriggerPrice > triggerPrice) {
                const finalDifference = updatedTriggerPrice - triggerPrice;
                trail_amount = Number(order.trail_amount) + finalDifference;
              } else {
                const finalDifference = triggerPrice - updatedTriggerPrice;
                trail_amount = Number(order.trail_amount) - finalDifference;
              }
              dispatch(
                editBracketOrder(
                  {
                    id: order.id,
                    product_id: order.product.id,
                    trail_amount: trail_amount.toString(),
                  },
                  {
                    chart: true,
                  }
                )
              ).catch(() => {
                if (orderLine.current) {
                  orderLine.current.setPrice(order.stop_price);
                  orderLine.current.setText(text);
                }
              });
            });
          } else if (isTakeProfitOrder) {
            if (order.trail_amount !== null) {
              orderLineInstance.onMove(function () {
                this.setText('Updating...');
                const triggerPrice = Number(order.stop_price);
                const updatedTriggerPrice = this.getPrice();
                let trail_amount;

                if (updatedTriggerPrice > triggerPrice) {
                  const finalDifference = updatedTriggerPrice - triggerPrice;
                  trail_amount = Number(order.trail_amount) + finalDifference;
                } else {
                  const finalDifference = triggerPrice - updatedTriggerPrice;
                  trail_amount = Number(order.trail_amount) - finalDifference;
                }
                dispatch(
                  editBracketOrder(
                    {
                      id: order.id,
                      product_id: order.product.id,
                      trail_amount: trail_amount.toString(),
                    },
                    {
                      chart: true,
                    }
                  )
                ).catch(() => {
                  if (orderLine.current) {
                    orderLine.current.setPrice(order.stop_price);
                    orderLine.current.setText(text);
                  }
                });
              });
            } else {
              orderLineInstance.onMove(function () {
                this.setText('Updating...');
                dispatch(
                  editBracketOrder(
                    {
                      id: order.id,
                      product_id: order.product.id,
                      stop_price: this.getPrice().toString(),
                    },
                    {
                      chart: true,
                    }
                  )
                ).catch(() => {
                  if (orderLine.current) {
                    orderLine.current.setPrice(order.stop_price);
                    orderLine.current.setText(text);
                  }
                });
              });
            }
          }

          orderLine.current = orderLineInstance;
        } catch (e) {
          console.error('DEBUG: Error creating stop order line', e);
          addLogsToSentry(user, `Error creating stop order line ${e}`);
        }
      }
    }, 1000);

    return function cleanUp() {
      clearTimeout(timeoutId);
      if (orderLine.current) {
        if (orderLine.current._line) {
          orderLine.current.remove();
        }
        orderLine.current = null;
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    order,
    dispatch,
    widgetRef.current,
    isChartReady,
    currentActiveTab,
    showOrderLine,
    activeChartSymbol,
  ]);

  useEffect(() => {
    if (previousTab?.current !== currentActiveTab) {
      setShowOrderLine(false);
      setTimeout(() => {
        setShowOrderLine(true);
      }, 1000);
    }
  }, [currentActiveTab]);

  return null;
};

const OpenStopOrdersWidget = ({
  isNewTab,
  widgetRef,
  isChartReady,
  currentActiveTab,
  activeChartSymbol,
  containerType,
}) => {
  const orders = useSelector(allOpenStopOrdersSelector);
  const futureBracketOrderIDs = useSelector(state =>
    futuresOpenStopOrdersSelector(state)
      .filter(order => order.bracket_order)
      .map(order => order.id)
  );
  const isChartBrokerEnabledFromGB = useGrowthbookFeatureValue('is_chart_broker_enabled');
  const isPositionShownFromBroker =
    isChartBrokerEnabledFromGB && containerType === 'futures';

  const ordersToBeConsidered =
    containerType === 'default' && isChartBrokerEnabledFromGB
      ? orders.filter(order => !futureBracketOrderIDs.includes(order.id))
      : orders;
  const filteredOrders = ordersToBeConsidered.filter(
    order =>
      activeChartSymbol?.includes(order?.product?.symbol) &&
      (!isPositionShownFromBroker || !order.bracket_order) // removing bracket orders as they will be shown by broker impl
  );
  return filteredOrders.map(order => (
    <OpenStopOrderLine
      key={order.id}
      order={order}
      isNewTab={isNewTab}
      widgetRef={widgetRef}
      isChartReady={isChartReady}
      currentActiveTab={currentActiveTab}
      activeChartSymbol={activeChartSymbol}
    />
  ));
};

export default OpenStopOrdersWidget;

// export default class OpenStopOrdersWidget extends React.Component {
//   shouldComponentUpdate(nextProps, nextState, nextContext) {
//     return this.props.openStopOrders !== nextProps.openStopOrders;
//   }

//   render() {
//     const { openStopOrders, isNewTab, widgetRef } = this.props;
//     return (
//       <>
//         {openStopOrders &&
//           openStopOrders.map(order => (
//             <OpenStopOrderLine
//               key={order.id}
//               order={order}
//               isNewTab={isNewTab}
//               widgetRef={widgetRef}
//             />
//           ))}
//       </>
//     );
//   }
// }
